<header class="freemium-premium-reverse-trial__header">
    <h2 class="freemium-premium-reverse-trial__title">{{'freemium.try_ile_for_free' | translate}}</h2>
    <p class="freemium-premium-reverse-trial__subtitle"
        [innerHTML]="'freemium.all_lessons_and_unlimited_access_for_3_weeks' | translate">
    </p>
</header>

<div class="freemium-premium-reverse-trial__content">
    <ul class="freemium-premium-reverse-trial__feature-list">
        <li class="freemium-premium-reverse-trial__feature-item">{{'freemium.all_lessons_from_cp_to_cm2' | translate}}</li>
        <li class="freemium-premium-reverse-trial__feature-item">{{'freemium.flashcards_and_the_language_lab' | translate}}</li>
        <li class="freemium-premium-reverse-trial__feature-item">{{'freemium.simplified_individual_access_dedicated_to_students' | translate}}</li>
        <li class="freemium-premium-reverse-trial__feature-item">{{'freemium.the_course_editor' | translate}}</li>
        <li class="freemium-premium-reverse-trial__feature-item">{{'freemium.tools-list' | translate}}</li>
        <li class="freemium-premium-reverse-trial__feature-item">{{'freemium.assignment_and_tracking_tools' | translate}}</li>
    </ul>
</div>

<footer class="freemium-premium-reverse-trial__footer">
    <button (click)="action(false)" class="freemium-premium-reverse-trial__postpone-button" data-e2e="freemium-premium-reverse-trial-postpone-trial">
        <span>{{'freemium.try_again_later' | translate}}</span>
    </button>
    <button (click)="action(true)" class="freemium-premium-reverse-trial__start-button" data-e2e="freemium-premium-reverse-trial-start-trial">
        <span>{{'freemium.start_trial' | translate}}</span>
        <mat-icon svgIcon="freemium-premium-reverse-trial__start-premium"></mat-icon>
    </button>
</footer>
